import type { RuntimeLayoutTab } from './runtimeLayoutAdapter'

/** Tab label for passport runtime grid — matches `PassportRuntimeV2Body` / builder (general tab i18n). */
export function runtimeTabTitle(
  tab: RuntimeLayoutTab,
  trs: (key: string, params?: Record<string, unknown>) => string,
): string {
  if (tab.id === 'general' && tab.label === 'general') {
    return trs('itf.passport_builder_general_tab')
  }
  return tab.label
}
